import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { User } from '../models/user.models';

@Injectable()
export class LoggingService {
  config({ email, firstName, lastName, userId }: User) {
    Sentry.setUser({ username: `${firstName} ${lastName}`, email, id: userId });
  }

  logError(msg: string, err: any, type: Sentry.SeverityLevel) {
    const status = parseInt(err?.code ?? err?.original?.status ?? err?.status);
    const details = err?.original || err;
    const url = details?.url?.split('?')[0]?.split('/v3')[1];

    switch (status) {
      case 0:
        return;
      case 500:
        msg = `Server Error: ${url}`;
        break;
    }

    Sentry.withScope(function (scope) {
      const error = new Error(details.message);
      error.name = msg;

      scope.setLevel(type);
      scope.setTransactionName(details.statusText);
      if (url) scope.setTag('api-route', url.replace(/\/\d+\//g, '/<id>/')); //remove ids from url for tagging
      Sentry.captureException(error, {
        extra: {
          url,
          status,
          responseBody: details.message + JSON.stringify(details?.error?.errors || details?.errors),
        },
      });
    });
  }
}
